import React, {
    memo,
    useEffect,
    useRef
} from 'react';

export default memo(function Selectize({items, inputClasses, onChange, options, placeholder, maxItems = 1, itemRenderer, optionRenderer, disabled}) {
    const selectRef = useRef(null);

    useEffect(() => {
        let value;
        const select = selectRef.current;

        $(select).selectize({
            dropdownClass: 'riq-select-dropdown',
            dropdownContentClass: 'riq-select-dropdown-content',
            inputClass: `riq-select-input ${inputClasses || ''}`,
            items: items,
            labelField: 'name',
            noEmptySelection: true,
            onChange: onChange,
            onDropdownOpen: function (dropdown) {
                if (maxItems === 1) {
                    const selectize = select.selectize;
                    value = selectize.getValue();
                    selectize.clear(true);
                }
                dropdown.find('[data-toggle=popover]').popover({
                    trigger: 'hover',
                    container: 'body',
                    placement: 'auto right',
                    html: true
                });
            },
            onDropdownClose: function (dropdown) {
                const selectize = select.selectize;
                const currentValue = selectize.getValue();
                if (!currentValue) {
                    selectize.setValue(value, true);
                }
                dropdown.find('[data-toggle=popover]').popover('destroy');
            },
            options: options,
            placeholder: placeholder,
            searchField: 'name',
            selectOnTab: true,
            sortField: [
                {
                    field: 'name',
                    direction: 'asc'
                },
                {
                    field: '$score'
                }
            ],
            wrapperClass: `riq-select`,
            valueField: 'id',
            maxItems: maxItems,
            render: {
                item: itemRenderer,
                option: optionRenderer
            },
            // highlight is broken in this version of selectize (see #37159)
            highlight: false
        });

        return () => {
            select.selectize.destroy();
        };
    }, [items, inputClasses, onChange, options, placeholder, maxItems, itemRenderer, optionRenderer]);

    useEffect(() => {
        const select = selectRef.current;
        if (disabled) {
            select.selectize.disable();
        } else {
            select.selectize.enable();
        }
    }, [disabled]);

    return (
        <div className='rule-type-select'>
            <select ref={selectRef}/>
        </div>
    );
});
